import axios from 'axios';

export const getAssetErrors = async (client_id: string, asset_id: string) => {
  try {
    const authHeader = 'bwdevenv'; // Replace if you're ready to use awsTokens
    const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/asset/errors`;
    const headers = {
      Authorization: authHeader,
      "Content-Type": "application/json",
    };
    const body = { client_id, asset_id };

    const response = await axios.post(url, body, { headers });

    return response.data;
  } catch (error: any) {
    console.error("Error fetching asset errors:", error?.response?.data || error.message);
    throw new Error("Failed to fetch asset errors");
  }
};

